import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API } from '../../services/axios.service';
import ApiUrls from '../../helper/ApiUrls';

export const fetchTools = createAsyncThunk(
    'tools/fetchTools',
    async ({ chatbotId, forceFetch = false }, { getState }) => {
        const state = getState();
        // Check if tools data for the specific chatbotId is already loaded and forceFetch is false
        if (state.tools.toolsData[chatbotId] && !forceFetch) {
            // If yes and forceFetch is not true, return the cached data without making an API call
            return {
                chatbotId,
                tools: state.tools.toolsData[chatbotId]
            };
        }
        // If not, make an API call to fetch the data
        const response = await API.get(ApiUrls.TOOLS(chatbotId));
        // console.log("tool response", response)
        return {
            forceFetch,
            chatbotId,
            tools: response.data.data.map(tool => ({
                label: tool.tool_name,
                value: tool.tool_id,
                name: tool.tool_name,
                description: tool.tool_description,
                files: tool.files
            }))
        };

    }
);


const initialState = {
    toolsData: {}, // Stores tools data keyed by chatbotId
    loading: false,
    error: null,
};

const toolsSlice = createSlice({
    name: 'tools',
    initialState,
    reducers: {
        // You can add reducers here for other actions
        addTool: (state, action) => {
            const { chatbotId, tool } = action.payload;

            // Check if the toolsData array for the given chatbotId exists, if not initialize it as an empty array
            if (!state.toolsData[chatbotId]) {
                state.toolsData[chatbotId] = [];
            }

            // Check if the tool to be added already exists in the toolsData array for the given chatbotId
            const toolExists = state.toolsData[chatbotId].some(existingTool => existingTool.value === tool.value);

            // If the tool does not exist, add it to the toolsData array
            if (!toolExists) {
                state.toolsData[chatbotId].push(tool);
            }
        },
    },
    extraReducers: {
        [fetchTools.pending]: (state, action) => {
            const { forceFetch } = action.meta.arg;
            if (!forceFetch) {
                state.loading = true;
            }
            state.error = null;
        },
        [fetchTools.fulfilled]: (state, action) => {
            const { chatbotId, tools } = action.payload;
            state.toolsData[chatbotId] = tools;
            state.loading = false;
        },
        [fetchTools.rejected]: (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        },
    },
});

export const { addTool } = toolsSlice.actions;


export default toolsSlice.reducer;
